/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export type ComponentsPlanComponent = {
  id?: number
  rating?: number
  name?: string
  price?: number
  content?: string
  button?: {
    id?: number
    title?: string
    url?: string
    style?: ComponentsPlanComponent.style
  }
  items?: Array<{
    id?: number
    title?: string
    isIncluded?: boolean
  }>
  isRecommended?: boolean
}
export namespace ComponentsPlanComponent {
  export enum style {
    PRIMARY = 'Primary',
    SECONDARY = 'Secondary',
    TERTIARY = 'Tertiary',
    ACCENT = 'Accent',
  }
}
